import { decrypt } from '@/common/utils/cryptoUtils';
import { useAppStore } from '@/modules/apps/store';
import { useAuthStore } from '@/modules/auth/store';
import { AxiosRequestConfig } from 'axios';
import { Method, RequestParams } from './types';

export const buildRequestConfig = async (
    method: Method,
    url: string,
    params: RequestParams = {},
    files?: RequestParams
): Promise<AxiosRequestConfig> => {
    const requestParams = await attachAuth(params);

    Object.keys(requestParams).forEach(key => {
        if (requestParams[key] == null || requestParams[key] == undefined) {
            delete requestParams[key];
        }
    });

    if (method === Method.GET || method === Method.DELETE) {
        return {
            url,
            method,
            params: requestParams
        };
    }

    const formData = new FormData();
    appendToFormData(formData, requestParams);
    appendToFormData(formData, files);

    return {
        url,
        method,
        data: formData
    };
};

const appendToFormData = (formData: FormData, params?: RequestParams): void => {
    if (!params) return;
    Object.entries(params).forEach(([key, value]) => {
        if (value == null) return;
        formData.append(key, value instanceof Blob ? value : String(value));
    });
};

const attachAuth = async (params: RequestParams = {}): Promise<RequestParams> => {
    const authStore = useAuthStore();
    const appStore = useAppStore();

    return {
        ...params,
        exoty_token: await decrypt(authStore.token || ''),
        appId: params.appId || appStore.appId
    };
};
